import React from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { imageURL } from '@everlane/media'
import RouterLink from 'base/components/router_link'
import classnames from 'classnames'

const MenuTile = ({
  url,
  image,
  className,
  onClick,
  onMouseEnter,
  text,
  width = '100%',
  height,
  imageWidth,
  imageHeight,
  imageOptions = {},
}) => {
  const tileClasses = classnames('menu-tile', className)

  const defaultMenuTileEventProperties = {
    url,
    name: text,
    type: 'image',
  }

  return (
    <RouterLink
      onClick={() => onClick(defaultMenuTileEventProperties)}
      onMouseEnter={event => onMouseEnter(event, defaultMenuTileEventProperties)}
      href={url}
      style={{
        width,
        height,
      }}
      className={tileClasses}
    >
      <img
        src={imageURL(image, {
          width: imageWidth,
          height: imageHeight,
          smartCrop: true,
          ...imageOptions,
        })}
        className="menu-tile__image"
        alt={text || 'marketing-image'}
      />
      <span className="menu-tile__caption">{text}</span>
    </RouterLink>
  )
}

export default function MenuTiles({
  className,
  menuImageItems = [],
  onClick,
  onMouseEnter,
  imageOptions = {},
}) {
  return (
    <div className="drop-down-menu__menu-tiles">
      {menuImageItems.map(menuImageItem => {
        return (
          <MenuTile
            {...menuImageItem}
            className={className}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            key={get(menuImageItem, 'url', null)}
            imageOptions={imageOptions}
          />
        )
      })}
    </div>
  )
}

MenuTiles.propTypes = {
  menuImageItems: PropTypes.arrayOf(PropTypes.shape(MenuTile.propTypes)).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

MenuTile.propTypes = {
  url: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string,
}
